module.exports = __webpack_public_path__ + "static/media/NUMBER1.87abfa11.svg";